<script>
  import { router } from '@inertiajs/svelte'
  
  let { alert = null, user = {}, qrCodeUrl = '' } = $props();
  
  let code = $state('');
  
  function replaceTFA() {
    router.patch('/two_factor_authentication/profile/totp');
  }
  
  function submitCode(event) {
    event.preventDefault();
    router.post('/two_factor_authentication/profile/totp', {
      code
    });
  }
</script>

<div class="tfa-setup-container">
  {#if alert}
    <p class="alert">{alert}</p>
  {/if}

  {#if user.otp_required_for_sign_in}
    <h1>Want to replace your existing 2FA setup?</h1>

    <p>Your account is already protected with two-factor authentication. You can replace that setup if you want to switch to a new phone or authenticator app.</p>

    <p><strong>Do you want to continue? Your existing 2FA setup will no longer work.</strong></p>

    <button class="replace-button" onclick={replaceTFA}>Yes, replace my 2FA setup</button>

    <hr>
  {/if}

  <h1>Upgrade your security with 2FA</h1>

  <h2>Step 1: Get an Authenticator App</h2>
  <p>First, you'll need a 2FA authenticator app on your phone. <strong>If you already have one, skip to step 2.</strong></p>
  <p><strong>If you don't have one, or you aren't sure, we recommend Microsoft Authenticator</strong>. You can download it free on the Apple App Store for iPhone, or Google Play Store for Android. Please grab your phone, search the store, and install it now.</p>

  <h2>Step 2: Scan + Enter the Code</h2>
  <p>Next, open the authenticator app, tap "Scan QR code" or "+", and, when it asks, point your phone's camera at this QR code picture below.</p>

  <figure class="qr-container">
    {#if qrCodeUrl}
      <img src={qrCodeUrl} alt="QR Code for TOTP setup" width="200" height="200" />
      <figcaption>Point your camera here</figcaption>
    {/if}
  </figure>

  <form onsubmit={submitCode}>
    <div class="form-group">
      <label for="code" class="form-label">After scanning with your camera, the app will generate a six-digit code. Enter it here:</label>
      <!-- svelte-ignore a11y_autofocus -->
      <input 
        id="code" 
        type="text" 
        bind:value={code} 
        required 
        autofocus 
        autocomplete="off"
        class="form-input" 
      />
    </div>
    
    <div class="form-actions">
      <button type="submit" class="verify-button">Verify and activate</button>
    </div>
  </form>
  
  <div class="back-link">
    <a href="/">Back</a>
  </div>
</div>

<style>
  .tfa-setup-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 2rem 1rem;
  }
  
  h1 {
    font-size: 1.875rem;
    font-weight: 600;
    margin-bottom: 1.5rem;
  }
  
  h2 {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
  
  .alert {
    color: #b91c1c;
    margin-bottom: 1rem;
    padding: 0.5rem;
    background-color: #fee2e2;
    border-radius: 0.375rem;
  }
  
  .qr-container {
    margin: 2rem 0;
    text-align: center;
  }
  
  .qr-container img {
    border: 1px solid #e5e7eb;
    padding: 0.5rem;
    background-color: white;
  }
  
  .qr-container figcaption {
    margin-top: 0.5rem;
    font-size: 0.875rem;
    color: #6b7280;
  }
  
  .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
  }
  
  .form-input {
    width: 100%;
    max-width: 300px;
    padding: 0.625rem;
    border: 1px solid #d1d5db;
    border-radius: 0.375rem;
    font-size: 1.125rem;
    letter-spacing: 0.1em;
  }
  
  .form-actions {
    margin-top: 1.5rem;
  }
  
  .verify-button, .replace-button {
    background-color: #047857;
    color: white;
    border: none;
    padding: 0.625rem 1.25rem;
    border-radius: 0.375rem;
    font-weight: 500;
    font-size: 1rem;
    cursor: pointer;
  }
  
  .verify-button:hover, .replace-button:hover {
    background-color: #065f46;
  }
  
  .back-link {
    margin-top: 1.5rem;
  }
  
  .back-link a {
    color: #047857;
    text-decoration: none;
  }
  
  .back-link a:hover {
    text-decoration: underline;
  }
  
  hr {
    margin: 2rem 0;
    border: 0;
    border-top: 1px solid #e5e7eb;
  }
</style>